<template>
  <section class="aboutus_container">
    <section class="aboutus_content_container">
      <article
        v-for="(art, index) in aboutData"
        :key="index"
        class="about_article"
      >
        <p>{{ art.title }}</p>
        <p v-if="Array.isArray(art.content)">
          <span v-for="(item, index) in art.content" :key="index">
            <a v-if="item.type === 'link'" :href="item.link" target="_blank">{{
              item.value
            }}</a>
            <span v-else>{{ item.value }}</span>
          </span>
        </p>

        <p v-else>{{ art.content }}</p>
      </article>
    </section>
    <WaveFooter />
  </section>
</template>

<script>
import WaveFooter from "@/components/WavFooter";
export default {
  name: "About",
  components: {
    WaveFooter,
  },
  computed: {
    aboutData() {
      const { lang } = this.$store.state;
      return this.$store.state[lang].about;
    },
  },
};
</script>

<style></style>
